import { Box, Heading } from '@chakra-ui/react';
import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip as TooltipLeaflet } from 'react-leaflet';
import './Tooltip.css';
import { StatusLine } from './StatusLine/StatusLine';

export function Tooltip({ name, position, statusAmounts }) {
  return (
    <TooltipLeaflet
      permanent
      direction="top"
      position={position}
      offset={[0, -5]}
      className="plot-tooltip"
    >
      <Box
        minWidth="155px"
        background="white"
        color="black"
        textAlign="left"
        display="flex"
        flexDir="column"
        alignItems="left"
        justifyContent="center"
        padding={2}
      >
        <Heading size="md" mt={0} mb={4}>
          {name}
        </Heading>
        <Box
          display="flex"
          flexDir="column"
          justifyContent="center"
          borderBottom="1px solid"
          borderColor="primary.border.default"
        >
          {statusAmounts &&
            Object.values(statusAmounts).map((status, index) => {
              if (!status.amount || status.amount === 0) return null;

              return (
                <StatusLine
                  key={index}
                  name={status.name}
                  objectKey={status.objectKey}
                  amount={status.amount}
                />
              );
            })}
        </Box>
      </Box>
    </TooltipLeaflet>
  );
}

Tooltip.propTypes = {
  name: PropTypes.string.isRequired,
  position: PropTypes.array.isRequired,
  statusAmounts: PropTypes.object.isRequired,
};
